import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { Function } from '../enums/authorization';

export const hasPermissionGuard: CanActivateFn = (route, state) => {
  const authorService = inject(AuthorizationService);
  let url = state.url.split('?')[0];

  let hasPermission;

   // ===== Routes có param =====
  if ( url.startsWith('/bt-khoi/ks/cb/') || url.startsWith('/bt-khoi/ks/nc/') ||
      url.startsWith('/bt-khoi/thxl-cb/') || url.startsWith('/bt-khoi/thxl-nc/')) {
    return authorService.isAuthorizationByPerm(
      Function.A_C_MNCLBLAHAULABTKHOI
    );
  } else  if ( url.startsWith('/bt-lop/ks/cb/') || url.startsWith('/bt-lop/ks/nc/' ) ||
      url.startsWith('/bt-lop/thxl-cb/') || url.startsWith('/bt-lop/thxl-nc/') ) {
    return authorService.isAuthorizationByPerm(
      Function.A_C_MNCLBLAHAULABTLOP
    );
  }  else  if (url.startsWith('/bt-dt/cb/') || url.startsWith('/bt-dt/nc/') ||
      url.startsWith('/bt-dt/ks/cb/') || url.startsWith('/bt-dt/ks/nc/' ) ||
      url.startsWith('/bt-dt/thxl-cb/') || url.startsWith('/bt-dt/thxl-nc/') ) {
    return authorService.isAuthorizationByPerm(
      Function.A_C_MNCLBLAHAULABTDT
    );

    
  } else if (url.startsWith('/khoa-sinh/v/') ) {
    return authorService.isAuthorizationByPerm(
      Function.A_C_MNCLBLAHAULABTKS
    );
  }
   else if (url.startsWith('/bt/thxl-cb/') || url.startsWith('/bt/thxl-nc/')||
        url.startsWith('/bt/ks/cb/') || url.startsWith('/bt/ks/nc/' ) ) {
    return authorService.isAuthorizationByPerm(
      Function.A_C_MNCLBLAHAULABT
    );
  }
  else {
    switch (url) {
      case '/':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_HOMEPAGE
        );
        break;
      case '/my-registration':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_HOMEPAGE
        );
        break;
      case '/profile':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_PROFILE
        );
        break;
      case '/profile/details':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_PROFILE
        );
        break;
     
      case '/profile/user-lhl-update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_PROFILE
        );
        break;
      case '/profile/change-password':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_CHANGEPASSWORD
        );
        break;
      case '/tk':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_DASHBOARD
        );
        break;
      case '/tk/clb':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDLHLCLB
        );
      break;
      case '/tk/khoi':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDLHLKHOI
        );
        break;
      case '/tk/lop':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDLHLLOP
        );
      break; 
      case '/tk/dt':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDLHLDT
        );
      break;        
      case '/clb-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
      case '/clb-mng/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
      case '/clb-mng/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
       case '/clb-mng/l':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
       case '/clb-mng/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
       case '/clb-mng/ob-l':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULA
        );
        break;
      case '/khoi-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULAKHOI
        );
        break;
      case '/khoi-mng/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULAKHOI
        );
        break;
      case '/khoi-mng/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULAKHOI
        );
        break;
      case '/lop-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULALOP
        );
        break;
      case '/lop-mng/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULALOP
        );
        break;
      case '/lop-mng/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULALOP
        );
        break;
      case '/dt-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULADT
        );
        break;    
      case '/dt-mng/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULADT
        );
        break; 
      case '/dt-mng/a':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULADT
        );
        break; 
       case '/dt-mng/l':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULADT
        );
        break;   
      case '/khoa-sinh':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTKS
        );
        break;
      case '/khoa-sinh/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTKS
       );
        break;
      case '/khoa-sinh/v':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTKS
       );
        break;
       case '/bqc-bcn':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
        break;
      case '/bqc-bcn/bqc':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
      break;
      case '/bqc-bcn/bqc/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
      break;
      case '/bqc-bcn/bqc/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
      break;
      case '/bqc-bcn/bcn':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
        break;
       case '/bqc-bcn/bcn/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
        break;
      case '/bqc-bcn/bcn/update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCN
        );
        break;
      case '/bt/cb':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABT
        );
        break;    
      case '/bt/cb/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABT
        );
        break;
      case '/bt/nc':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABT
        );
        break;
      case '/bt/nc/add':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABT
        );
        break;
      case '/bt-khoi':
          hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTKHOI
        );
        break;
      case '/bt-lop':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTLOP
        );
        break;
      case '/bt-dt':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABTDT
        );
        break;
       case '/k-l-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULAKLLHL
        );
        break;
      case '/sp-clb':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBLHLBLD
        );
        break;
      case '/sp-k':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBLHLKHOI
        );
        break;
      case '/sp-l':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBLHLLOP
        );
        break;
      case '/sp-dt':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBLHLDT
        );
        break;
      case '/bpt-bcn-k':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
        break;
      case '/bpt-bcn-k/bpt':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
      break;
      case '/bpt-bcn-k/bpt/a':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
      break;
      case '/bpt-bcn-k/bpt/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
      break;
      case '/bpt-bcn-k/bcn':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
        break;
       case '/bpt-bcn-k/bcn/a':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
        break;
      case '/bpt-bcn-k/bcn/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFKHOI
        );
        break;
      case '/bcn-l':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFLOP
        );
        break;  
      case '/bcn-l/a':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFLOP
        );
      break;
      case '/bcn-l/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBLAHAULABCNFLOP
        );
      break;
    }
  }

  if (hasPermission) {
    return true;
  }
  return false;
};
